import { format, addMonths, subMonths } from 'date-fns';

import { useDateLocale } from '@/common/hooks/useDateLocale';

interface MonthSelectorProps {
  currentDate: Date;
  onMonthChange: (date: Date) => void;
}

export const MonthSelector = ({ currentDate, onMonthChange }: MonthSelectorProps) => {
  const { locale } = useDateLocale();
  return (
    <div className="flex items-center justify-between mb-4">
      <button
        className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
        onClick={() => onMonthChange(subMonths(currentDate, 1))}
      >
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path d="M15 19l-7-7 7-7" strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} />
        </svg>
      </button>

      <h2 className="text-xl font-medium text-gray-900">
        {format(currentDate, 'MMMM yyyy', { locale })}
      </h2>

      <button
        className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
        onClick={() => onMonthChange(addMonths(currentDate, 1))}
      >
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path d="M9 5l7 7-7 7" strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} />
        </svg>
      </button>
    </div>
  );
};
